/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import { FunctionComponent } from "react";

import { StrapiBenefitItem } from "@/types/strapi";

import { BorderRadiuses } from "@/tokens/border";
import { Colors } from "@/tokens/color";
import { Spacing } from "@/tokens/spacing";

import { Icon } from "@/ui/atoms/icon";
import { Text } from "@/ui/atoms/text";

import { buildStylesByBreakpoint } from "@/util/style_util";
import { convertToRem } from "@/util/ui_util";

import { RichText } from "./rich_text";

interface PrivacyOverviewItemProps extends StrapiBenefitItem {
    className?: SerializedStyles;
}

export const PrivacyOverviewItem: FunctionComponent<
    PrivacyOverviewItemProps
> = (props) => {
    /**
     * Styles
     */
    const OverviewItemTitleStyles = css({
        alignItems: "center",
        columnGap: Spacing["spacing-half"],
        display: "flex",
        justifyContent: "space-between",
        marginBottom: Spacing["spacing-3"],
    });

    const marginBottomStyles = buildStylesByBreakpoint("marginBottom", {
        extraSmall: Spacing["spacing-3"],
        large: Spacing["spacing-4"],
    });

    const iconStyles = css(marginBottomStyles, {
        alignItems: "center",
        background: Colors["lighten-10"],
        borderRadius: BorderRadiuses.borderLarge,
        display: "flex",
        height: convertToRem(22),
        justifyContent: "center",
        padding: Spacing["spacing-half"],
        width: convertToRem(22),
    });

    /**
     * Elements
     */
    return (
        <div css={props.className}>
            {props.Icon && (
                <Icon
                    className={iconStyles}
                    color="lighten-90"
                    fontSize="LongformTextDefault"
                    slug={props.Icon}
                />
            )}

            {props.Headline && (
                <Text
                    className={OverviewItemTitleStyles}
                    fontSize="LongformTextDefault"
                    fontWeight="medium"
                    labelLineHeight={false}
                    tag="h2"
                >
                    {props.Headline}
                </Text>
            )}

            {props.Description && (
                <RichText config="Longform">{props.Description}</RichText>
            )}
        </div>
    );
};
